import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Button, Space, Row } from "@masterteam/mt-design-react";

import { ReactComponent as AdminIcon } from "../../assets/images/admin.svg";
import PPusLogo from "../../assets/images/pplus-logo.png";
import { logoURL } from "../../providers/config/urlServiceConfig";
import Notifications from "../Notifications";
import UserDropdown from "./UserDropdown";
import useIsAr from "../../Hooks/useIsAr";
import { toggleLanguage } from "../../reducers/language";
import { deactivateDelegation } from "../../reducers/user";

import styles from "./Header.module.scss";

function Header() {
  const [mainUser, currentUser] = useSelector(({ user }) => [
    user.mainUser,
    user.user,
  ]);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isAr] = useIsAr();

  const handleLanguage = () => {
    dispatch(toggleLanguage());
  };

  const handleCentralAdmin = () => {
    history.push("/administration");
  };

  const stopDelegation = () => {
    dispatch(deactivateDelegation());
  };

  const showAdminPanel = currentUser?.screens?.includes("CA");

  return (
    <Row className={styles.header} justify="between" align="center">
      <Link to="/">
        <Space align="center" size="medium">
          <img src={logoURL} alt="logo" className={styles.logo} />
          <span>
            {window.env?.[isAr ? "HEADER_TITLE_AR" : "HEADER_TITLE"] || (
              <FormattedMessage id="header-title" />
            )}
          </span>
        </Space>
      </Link>
      {mainUser?.UserName !== currentUser?.UserName && (
        <Space
          align="center"
          direction="vertical"
          className={styles.delegation}
        >
          <FormattedMessage
            id="delegation.loggedin-as"
            values={{ name: currentUser?.DisplayName }}
          />
          <Button fill="none" variant="primary" onClick={stopDelegation}>
            <FormattedMessage id="delegation.back-to-account" />
          </Button>
        </Space>
      )}
      <Space align="center">
        <Button
          variant="dark"
          fill="none"
          size="medium"
          onClick={() => handleLanguage()}
          tooltip-position="buttom"
          tooltip={isAr ? "اللغات" : "Languages"}
        >
          {isAr ? "English" : "العربية"}
        </Button>
        {showAdminPanel ? (
          <Button
            fill="none"
            size="medium"
            onClick={() => handleCentralAdmin()}
            Icon={AdminIcon}
          >
            {isAr ? "الإدارة المركزية" : "Central Administration"}
          </Button>
        ) : null}

        <Notifications />

        <UserDropdown />
      </Space>
    </Row>
  );
}

export default Header;
